import type { DemoAlert, DemoAppointment, DemoPatient } from './types';

/** Pacientes de demonstração até o app mobile popular child_access. */
export const DEMO_PATIENTS: DemoPatient[] = [
  {
    id: 'demo-1',
    name: 'Pequeno Theo',
    age: '4 meses',
    parents: 'Maria e João',
    photo: '👶',
    weight: 6.2,
    height: 62,
    formula: 'Nan Pro 1',
    lastSeen: 'Hoje',
    alert: true,
    alertMsg: 'Febre 38.4°C · diário enviado',
    source: 'demo',
  },
  {
    id: 'demo-2',
    name: 'Pequena Luna',
    age: '8 meses',
    parents: 'Ana Paula',
    photo: '👧',
    weight: 7.8,
    height: 68,
    formula: 'Aptamil 2',
    lastSeen: 'Ontem',
    alert: false,
    alertMsg: null,
    source: 'demo',
  },
  {
    id: 'demo-3',
    name: 'Pequeno Miguel',
    age: '2 meses',
    parents: 'Carla e Pedro',
    photo: '🍼',
    weight: 4.9,
    height: 55,
    formula: 'Prematuro ESP',
    lastSeen: '3 dias',
    alert: false,
    alertMsg: null,
    source: 'demo',
  },
];

export const DEMO_APPOINTMENTS: DemoAppointment[] = [
  {
    id: 'a1',
    date: 'HOJE',
    time: '09:30',
    baby: 'Pequeno Theo',
    type: 'Rotina 4 meses',
    status: 'proxima',
  },
  {
    id: 'a2',
    date: 'HOJE',
    time: '14:00',
    baby: 'Pequena Luna',
    type: 'Seguimento PNI',
    status: 'proxima',
  },
  {
    id: 'a3',
    date: '26/05',
    time: '10:00',
    baby: 'Pequeno Miguel',
    type: 'Primeira consulta pós-alta',
    status: 'proxima',
  },
];

export const DEMO_ALERTS: DemoAlert[] = [
  {
    id: 'al1',
    patientName: 'Pequeno Theo',
    message: 'Febre 38.4°C registrada às 02:14 · diário de doença enviado',
    severity: 'high',
    when: 'Hoje, madrugada',
  },
];
